import { useCallback as e, useEffect as t, useRef as n, useState as r } from "react";
import { parseCalendarView as i } from "@maat/datetime";
//#region src/components/DatePicker/hooks/useCalendarNavigation.ts
var a = (e) => ({
	year: e.getFullYear(),
	month: e.getMonth()
});
function o({ defaultMonth: o, initialValue: s, onLoadMore: c } = {}) {
	let l = n(o ? a(o) : s ? i(s) : a(/* @__PURE__ */ new Date())).current, [u, d] = r(l), f = e((e) => {
		d((t) => {
			let n = t.month + e;
			return {
				month: (n + 12) % 12,
				year: t.year + (n < 0 ? -1 : n > 11 ? 1 : 0)
			};
		});
	}, []), p = (u.year - l.year) * 12 + (u.month - l.month), m = (u.month + 1) % 12, h = u.month === 11 ? u.year + 1 : u.year, g = e((e) => {
		let t = l.month + e;
		return {
			year: l.year + Math.floor(t / 12),
			month: (t % 12 + 12) % 12
		};
	}, [l.year, l.month]), _ = n(0);
	return t(() => {
		c && p > _.current && (_.current = p, c());
	}, [p, c]), {
		view: u,
		setView: d,
		navigate: f,
		monthOffset: p,
		nextMonth: m,
		nextYear: h,
		offsetMonth: g
	};
}
//#endregion
export { o as useCalendarNavigation };
